<div class="sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onRefresh()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-dark">
      <mat-icon> refresh </mat-icon>
    </button>

    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent sp-margin__left">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div
    *ngIf="is_list_long_ranges_running"
    class="sp-column__center sp-width__full sp-padding__x2">
    <mat-spinner
      color="accent"
      diameter="40"></mat-spinner>
    <p class="sp-color__accent sp-text__center sp-margin__top">Loading...</p>
  </div>

  <div
    *ngIf="!is_list_long_ranges_running && !store?.order_requirements?.is_bnpl_long_enabled"
    class="sp-padding__x4">
    <h3 class="sp-color__primary sp-text__center">{{ 'STORES.BNPL_LONG_DISABLED' | translate }}</h3>
  </div>

  <div
    *ngIf="!is_list_long_ranges_running && store?.order_requirements?.is_bnpl_long_enabled"
    class="sp-width__full sp-padding__x2">
    <h3 class="sp-color__primary sp-margin__bottom">{{ 'STORES.LONG_RANGE_TITLE' | translate }} {{ store?.name }}</h3>

    <table
      mat-table
      [dataSource]="default_long_ranges || []"
      class="sp-width__full sp-table__headerless">
      <ng-container matColumnDef="amount_range">
        <th
          mat-header-cell
          *matHeaderCellDef>
          <!--<span class="sp-text__ellipsized">
            {{ 'ORDERS.AMOUNT_COLUMN_LABEL' | translate }}
          </span>-->
        </th>
        <td
          mat-cell
          *matCellDef="let long_range">
          <span> {{ getLongRangeLabel(long_range).min_label }} - {{ getLongRangeLabel(long_range).max_label }}€ </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="allowed_steps">
        <th
          mat-header-cell
          *matHeaderCellDef>
          <!--<span class="sp-text__ellipsized">
            {{ 'STORES.LONG_RANGE_TITLE' | translate }}
          </span>-->
        </th>
        <td
          mat-cell
          *matCellDef="let long_range">
          <div class="sp-row__align">
            <mat-checkbox
              *ngFor="let step of long_range.allowed_steps"
              [class]="isChecked(step, long_range) ? 'sp-color__green' : ''"
              [checked]="isChecked(step, long_range)"
              [disabled]="!isChecked(step, long_range)"
              (click)="$event.preventDefault()"
              class="sp-margin__right-x4">
              <span>{{ step }}</span>
            </mat-checkbox>
          </div>
        </td>
      </ng-container>
      <tr
        mat-header-row
        *matHeaderRowDef="displayed_columns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayed_columns"></tr>
    </table>
  </div>
</div>
